import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/@shared/services/common.service';
import { MessageService } from 'src/app/@shared/message/message.service';

@Component({
  selector: 'app-sport-setting',
  templateUrl: './sport-setting.component.html',
  styleUrls: ['./sport-setting.component.css']
})
export class SportSettingComponent implements OnInit {

  public api = api;
  public env = environment;
  public data: any;
  private subs: Subscription[] = [];
  private uId: any;
  public eventTypes: any[] = [];
  submitted = false;

  constructor(public service: WebserviceService,
    private _common: CommonService,
    private _message: MessageService,
    private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    const sub1 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid') + this.api.getSportSetting}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (res?.data?.message && (res?.data?.message != '' || res?.data?.message != null)) {
            this._message.errmessage(res?.data?.message);
            this._common.back();
          } else {
            this.data = res.data;

            this.data?.sports.forEach((element: any) => {
              element["isChecked"] = (element?.is_blocked == null) ? true : false
            });
          }
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  onSubmit() {
    this.submitted = true;
    let req: any = {};
    console.log(this.data?.sports);

    this.data?.sports.forEach((element: any) => {
      if (element?.isChecked == true) {
        req[`sport_${element.id}`] = 1;
      }
    });
    console.log(req); 

    const sub2 = this.getServices().Post(`${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid') + this.api.saveSportSetting}`, this._common.JSON_to_formData(req)).subscribe(
      (res) => {
        if (res.status == true) {
          this._message.succmessage(res?.data?.message);
          this._common.back();
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
          }
        }

        this.submitted = false;
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub2)
  }

  ngDoCheck() {
    if (this.uId != this.actRoute.snapshot.paramMap.get('uid')) {
      this.uId = this.actRoute.snapshot.paramMap.get('uid');
      this.getData();
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}

